import { getServices } from "../resources/api-constants"
import { Office } from "../types/offices"
import { Service } from "../types/services"
import CustomAxios from "./customAxios"

/**
 * Recupera tutti i servizi erogati da tutti gli uffici
 * @param offices Lista degli uffici da cui ricavare i servizi erogati
 * @returns Lista dei servizi
 */
export const setAllServices = async (offices: Office[]): Promise<Service[]> => {
    let array: Service[] = []
    try {
        for(const off of offices) {
            const s: Service[] = await CustomAxios.get(getServices(off.id)).then((response) => response.data.items)
            array = [...array, ...s]
        }
    } catch (error) {
        console.error(error)
    }
    return array.sort((a: any, b: any) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
}
